import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const customConfig = defineConfig({
  theme: {
    tokens: {
      colors: {
        primary: {
          900: { value: "#000000" },
          800: { value: "#000000" },
          700: { value: "#131925" },
          600: { value: "#131925" },
          500: { value: "#131925" },
          400: { value: "#9CA4B1" },
          300: { value: "#CFD5DE" },
          200: { value: "#E4E8EF" },
          100: { value: "#EFF2F6" },
          50: { value: "#F9FAFC" },
          0: { value: "#FFFFFF" },
        },
        success: {
          50: { value: "#F5FEE9" },
          100: { value: "#E8FAD1" },
          200: { value: "#D8F7B3" },
          400: { value: "#9BDF58" },
          600: { value: "#63A132" },
        },
        error: {
          100: { value: "#FAE5E3" },
          600: { value: "#EE4646" },
          800: { value: "#C53731" },
          900: { value: "#C53731" },
        },
      },
      fontSizes: {
        "12": { value: "12px" },
        "14": { value: "14px" },
        "16": { value: "16px" },
        "18": { value: "18px" },
        "24": { value: "24px" },
        "28": { value: "28px" },
        "32": { value: "32px" },
        "40": { value: "40px" },
      },
      fontWeights: {
        light: { value: 300 },
        regular: { value: 400 },
        medium: { value: 500 },
      },
      lineHeights: {
        normal: { value: "150%" },
        bigger: { value: "175%" },
        big: { value: "200%" },
      },
    },
    semanticTokens: {
      colors: {
        // Background colors that respond to color mode
        'neutral.900': {
          value: { _light: '#FFFFFF', _dark: '#000000' }
        },
        'neutral.800': {
          value: { _light: '#F9FAFC', _dark: '#111111' }
        },
        'neutral.700': {
          value: { _light: '#EFF2F6', _dark: '#1A1A1A' }
        },
        'neutral.600': {
          value: { _light: '#CFD5DE', _dark: '#383838' }
        },
        'neutral.500': {
          value: { _light: '#9CA4B1', _dark: '#6C7585' }
        },
        'neutral.400': {
          value: { _light: '#6C7585', _dark: '#9CA4B1' }
        },
        'neutral.300': {
          value: { _light: '#383838', _dark: '#CFD5DE' }
        },
        'neutral.200': {
          value: { _light: '#1A1A1A', _dark: '#E4E8EF' }
        },
        'neutral.100': {
          value: { _light: '#111111', _dark: '#EFF2F6' }
        },
        'neutral.50': {
          value: { _light: '#000000', _dark: '#F9FAFC' }
        },
        'neutral.0': {
          value: { _light: '#000000', _dark: '#FFFFFF' }
        },
      },
    },
    breakpoints: {
      sm: "576px",
      md: "768px",
      lg: "992px",
      xl: "1200px",
      xxl: "1400px",
    },
  },
});

export const system = createSystem(defaultConfig, customConfig);
